import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";

export default function Home() {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const stringTeacher = localStorage.getItem("teacher");
    if (stringTeacher) {
      const teacher = JSON.parse(stringTeacher);
      setUser(teacher);
    }

    setReady(true);
  }, []);

  if (ready && user) {
    if (user.can_review_question) {
      return <Redirect to="/questionMatch" />;
    } else if (user.can_review_answer) {
      return <Redirect to="/answerMatch" />;
    } else {
      return <div>no permissions!!!!</div>;
    }
  }
  if (ready && !user) return <Redirect to={"/login"} />;
  return <div>waiting!!!!</div>;
}
